<!-- filepath: c:\Users\lawi\Sandbox\loop_reporting_feb\frontend\src\componentsv3\WaveBoard\WaveCard.vue -->
<template>
  <div
    class="wave-card"
    :class="{ 'is-completed': isCompleted }"
    @click="$emit('click', wave)">

    <!-- Header -->
    <div class="wave-card-header">
      <div class="wave-info">
        <div class="status-indicator" :class="`status-${wave.status}`"></div>

        <div class="wave-title-group">
          <div class="wave-badges">
            <span class="wave-name">{{ wave.Name || 'NAME' }}</span>
            <span class="badge">{{ wave.country || 'COUNTRY' }}</span>
            <span class="badge">{{ wave.category || 'CATEGORY' }}</span>
          </div>
          <p class="wave-deadline">
            Deadline: {{ formatDeadline(wave.deadline) }}
          </p>
        </div>
      </div>

      <component
        :is="statusIcon"
        :size="20"
        class="status-icon"
      />
    </div>

    <!-- Stats Grid -->
    <div class="">
      <div class="wave-stats" style="    padding-left: 1.25rem;">
        <div class="stat-item">
          <p class="stat-label">{{ $t('Webportal.Implementation')}}</p>
          <p class="stat-value">{{ wave.total }}</p>
        </div>

        <div class="stat-item">
          <p class="stat-label">{{ $t('Webportal.Completed')}}</p>
          <p class="stat-value stat-completed">{{ wave.completed }}</p>
        </div>

        <div class="stat-item">
          <p class="stat-label">{{ $t('Webportal.InProgress')}}</p>
          <p class="stat-value stat-processing">{{ wave.processing }}</p>
        </div>

        <div class="stat-item">
          <p class="stat-label">{{ $t('Webportal.Claimed')}}</p>
          <p class="stat-value stat-claimed">{{ wave.claimed }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Play, CircleCheckBig } from 'lucide-vue-next';

export default {
  name: 'WaveCard',

  components: {
    Play,
    CircleCheckBig
  },

  props: {
    wave: {
      type: Object,
      required: true
    }
  },

  emits: ['click'],

  computed: {
    isCompleted() {
      return this.wave.status === 'completed';
    },

    statusIcon() {
      return this.isCompleted ? CircleCheckBig : Play;
    }
  },

  methods: {
    formatDeadline(deadline) {
      const now = new Date();
      const deadlineDate = new Date(deadline);
      const diffTime = deadlineDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays > 0) {
        return diffDays === 1 ? 'Morgen' : `in ${diffDays} Tagen`;
      } else if (diffDays === 0) {
        return 'Heute';
      } else {
        const absDays = Math.abs(diffDays);
        return absDays === 1 ? 'vor 1 Tag' : `vor ${absDays} Tagen`;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wave-card {
  padding: 1rem;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.5rem;
  background-color: var(--bs-body-bg);
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover {
    // border-color: rgba(2, 54, 112, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: scale(0.99);
  }
}

.wave-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.wave-info {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  flex: 1;
}

.status-indicator {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: .5rem;

  &.status-active {
    background-color: var(--default-status-yellow); // yellow-500
  }
  &.status-completed {
    background-color: var(--default-status-green); // green-500
  }
  &.status-planned {
    background-color: var(--default-status-indifferent); // blue-500
  }
}

.wave-title-group {
  flex: 1;
}

.wave-badges {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.25rem;
}

.wave-name {
  font-weight: 500;
  color: var(--bs-body-color);
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.125rem 0.5rem;
  font-size: 0.75rem;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.375rem;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
}

.wave-deadline {
  font-size: 0.75rem;
  color: var(--bs-secondary-color);
  margin: 0;
}

.status-icon {
  flex-shrink: 0;
  color: var(--bs-secondary-color);
}

.wave-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-label {
  font-size: 0.75rem;
  color: var(--bs-secondary-color);
  margin: 0;
}

.stat-value {
  font-weight: 500;
  color: var(--bs-body-color);
  margin: 0;

  &.stat-completed {
    color: var(--default-status-green); // green-600
  }

  &.stat-processing {
    color: var(--default-status-yellow); // yellow-600
  }

  &.stat-claimed {
    color: var(--default-status-red); // red-600
  }
}
</style>
